import * as React from 'react'

import get from 'lodash/get'

import { CommerceToolsApi } from '@grandvisionhq/commercetools'
import { IFrame } from '@grandvisionhq/common'
import { Helpers } from '@grandvisionhq/products'
import { useIntl } from '@grandvisionhq/state'
import { getAttrValue, getLocalizedAttrValue } from '@grandvisionhq/utils'

import { getPrice } from './get-price'

type Props = {
  id: string
  product: CommerceToolsApi.ProductProjection
}

const SSP: React.FC<Props> = ({ id, product }) => {
  const { getLabel, locale } = useIntl()
  const language = locale.substr(0, 2)

  if (!product) {
    return null
  }

  const { masterVariant } = product

  const price = getPrice(masterVariant, locale)

  if (!price) {
    return null
  }

  const { sku } = masterVariant
  const frameType = getLocalizedAttrValue(masterVariant, 'frameType', locale)
  const brand = getAttrValue(masterVariant, 'brand')
  const productName = Helpers.getProductTitle('Frames', product, masterVariant, locale)
  const condition = get(price, 'discountedPrice.name', '')
  const totalPrice = get(price, 'discountedPrice.amount') || price.originalPrice

  return (
    <IFrame
      source={`https://grandvision.s3.amazonaws.com/${id}/ssp/ssp.html?sku=${sku}&lng=${language}&condition=${condition}&type=${frameType}&name=${productName}&brand=${brand}&price=${totalPrice}&iframeId=pdpSspIframe`}
      scrolling={false}
      title={getLabel('products.screenreader.sspTitle')}
    />
  )
}

export default SSP
